import * as React from 'react';
import Box from '@mui/material/Box';
import Popper, { PopperPlacementType } from '@mui/material/Popper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useEffect } from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';

// const options = [
// 	'Show some love to MUI',
// 	'Show all notification content',
// 	'Hide sensitive notification content',
// 	'Hide all notification content',
// ];

export default function ListButton(props: any) {
	const { options, label, cb } = props;
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
		null
	);
	const [open, setOpen] = React.useState(false);
	const [placement, setPlacement] = React.useState<PopperPlacementType>();
	const [state, setState] = React.useState<any>({});

	const handleClick =
		(newPlacement: PopperPlacementType) =>
		(event: React.MouseEvent<HTMLButtonElement>) => {
			setAnchorEl(event.currentTarget);
			setOpen((prev) => placement !== newPlacement || !prev);
			setPlacement(newPlacement);
		};
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setState({
			...state,
			[event.target.name]: event.target.checked,
		});
		// console.log(state);
	};

	// const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
	// 	setState({
	// 	  ...state,
	// 	  [event.target.name]: event.target.checked,
	// 	});
	//   };
	// const KodSugMichraz = Object.entries(fields.KodSugMichraz);
	useEffect(() => {
		const checkboxStateInit: any = {};
		options?.forEach((x: any, index: number) => {
			checkboxStateInit[`checkbox-lable-${x[0]}`] = true;
			// setState({ ...state, [`checkbox-lable-${index}`]: true });
		});
		setState(checkboxStateInit);
	}, []);
	const sendForm = () => {
		// console.log(state);
		// regex get only numbers
		const result = 'vcxvcxv-cvxcv10';
		// console.log(result.match(/[0-9]+/g));
		const tempFilter: any = [];
		Object.entries(state).forEach((x: any) => {
			if (x[1]) {
				tempFilter.push(x[0] ? String(x[0].match(/[0-9]+/g)[0]) : '');
			}
			// console.log(x[0].match(/[0-9]+/g)[0]);
			// console.log(x[1]);
		});
		cb(tempFilter);
	};
	const handleClose = (event: Event | React.SyntheticEvent) => {
		if (anchorEl && anchorEl.contains(event.target as HTMLElement)) {
			return;
		}

		setOpen(false);
	};
	return (
		<Box>
			<ClickAwayListener onClickAway={handleClose}>
				<Popper
					style={{ zIndex: 10000 }}
					open={open}
					anchorEl={anchorEl}
					placement={placement}
					transition
				>
					{({ TransitionProps }) => (
						// eslint-disable-next-line react/jsx-props-no-spreading
						<Fade {...TransitionProps} timeout={350}>
							<Paper>
								{/* <Typography sx={{ p: 2 }}>
									The content of the Popper.
								</Typography> */}

								<FormGroup>
									<Box pl={2}>
										{options?.map((x: any, index: number) => (
											<Box key={x[0]}>
												<FormControlLabel
													control={
														<Checkbox
															defaultChecked
															onChange={handleChange}
															name={`checkbox-lable-${x[0]}`}
															id={`checkbox-lable-${x[0]}`}
														/>
													}
													label={x[1]}
												/>
											</Box>
										))}
									</Box>
									<Box pl={2} pb={2} pt={2}>
										{' '}
										<Button variant="contained" onClick={sendForm}>
											החל
										</Button>
									</Box>
								</FormGroup>
							</Paper>
						</Fade>
					)}
				</Popper>
			</ClickAwayListener>

			<Button onClick={handleClick('bottom-start')}>{label}</Button>
		</Box>
	);
}
